import { render } from "./PreloadedValue.vue?vue&type=template&id=2177c035"
import script from "./PreloadedValue.vue?vue&type=script&lang=js"
export * from "./PreloadedValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__